module.exports = __webpack_public_path__ + "static/media/loader.0b64a0a7.gif";